import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-24 md:py-40 px-6 bg-cream relative overflow-hidden" data-id="element-138">
      <div className="absolute inset-0 bg-gradient-to-b from-cream via-[#fbf3e9] to-cream pointer-events-none" data-id="element-139"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="font-serif text-3xl md:text-4xl text-sage italic mb-10" data-id="element-142">
            Imagine la diferencia en 7 días...
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-143">
          <p className="text-xl md:text-2xl text-charcoal leading-relaxed mb-6 font-light" data-id="element-144">
            Esa carpeta azul estará lista. Ese peso en sus hombros desaparecerá.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-145">
          <p className="text-lg md:text-xl text-muted leading-relaxed" data-id="element-146">
            Sus hijos sentirán un alivio inmenso al saber que usted ha pensado
            en todo para protegerlos.
          </p>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-147">
          <div className="mt-12 flex justify-center" data-id="element-148">
            <div className="w-16 h-px bg-gold/50" data-id="element-149"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}